<template>
  <button type="button" class="hot-button hot-button--secondary checkout-overlay-button" :class="[type]" @click="$emit('click', $event)">
    <slot></slot>
  </button>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-button {
    &:hover {
      opacity: .8;
    }
  }

  .on-bottom {
    width: 100%;
    border-radius: 0;
    background-color: $color-green;
    color: #fff;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;

    &:disabled {
      pointer-events: none;
      opacity: 1;
      background: #979797;
    }
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-button',
    props: {
      type: String
    }
  }
</script>
